import { sveaCheckoutApi } from './checkout'

export const sveaApi = {
  checkout: sveaCheckoutApi
}
